import { useMemo } from 'react';
import 'prop-types';
import { useDispatch } from 'react-redux';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

const useBoundEventCreator=withConformsTo("useBoundEventCreator",[],a=>{// eslint-disable-next-line @dbh/redux-extra/use-create-use-bound-event-creator
const b=useDispatch(),c=useMemo(()=>function(){return b(a(...arguments))},[b,a]);return c}),createUseBoundEventCreator=withConformsTo("createUseBoundEventCreator",[],a=>()=>useBoundEventCreator(a));

export { createUseBoundEventCreator as default };
